import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  HStack,
  Button,
  Menu,
  MenuButton,
  useDisclosure,
  Stack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  Image,
  useTheme,
  useColorMode,
  useColorModeValue,
  Grid,
  GridItem,
  // keyframes,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import '@fontsource/lora';
import { keyframes } from '@emotion/react';

export default function Header() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const theme = useTheme();
  const [showServices, setShowServices] = useState(false);

  const handleServicesClick = () => {
    setShowServices(!showServices);
  };

  useEffect(()=>{
    if(showServices){
      if(!isOpen){
        setShowServices(!showServices)
      }
    }
  }, [isOpen])

  const handleLinkClick = () => {
    onClose();
  };
  const { colorMode, toggleColorMode } = useColorMode();

  const bg = useColorModeValue('white', '#121111')
  const color = useColorModeValue('#FFFFF', 'white')
  // Keyframe for opening animation
  const diagonalSlideAnimation = keyframes`
  0% {
      transform: translate(-100%, -100%);
    }
    100% {
      transform: translate(0, 0);
    }
  `;


  return (
    <>
      <Box
        as="header"
        bg={useColorModeValue('white', '#1C1C1C')}
        top={0}
        left={0}
        right={0}
        zIndex={1000}
        pt={{ base: theme.space.padding.mobile, md: theme.space.padding.desktop }}
        pb={{ base: theme.space.padding.mobile, md: theme.space.padding.desktop }}
        px={{ base: theme.space.margin.mobile, md: theme.space.margin.desktop }}
      >
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'} position="relative">
          <HStack spacing={2} onClick={onOpen} cursor="pointer" color={color}>
            <Box fontSize="35" display={{ base: 'none', md: 'block' }} fontFamily="'Gilroy-Regular', sans-serif">
              Menu
            </Box>
            <Image
              src={colorMode == "light" ? "/assets/images/svg/headerarrowblack.svg" : "/assets/images/svg/arrow.svg"}
              alt="Arrow Icon"
              cursor="pointer"
              height="auto"
              width="auto"
            />
          </HStack>

          {/* Center Logo */}
          <HStack
            position={{ base: 'absolute', md: 'static' }}
            left="50%"
            transform={{ base: 'translateX(-50%)', md: 'none' }}
          >
            src={colorMode == "light" ? "/assets/images/svg/headerarrowblack.svg" : "/assets/images/svg/arrow.svg"}

            <Link to="/">
              <Image
                height="53px"
                width="427px"
                src={
                  colorMode === 'light'
                    ? '/assets/images/svg/RARETOSS_LOGO_BLACK.svg'
                    : '/assets/images/svg/RARETOSS_LOGO_WHITE.svg'
                }
                alt="raretoss"
                cursor="pointer"
              />
            </Link>
          </HStack>
          <HStack>
            <Box>
              <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(4, 1fr)' }} gap={3}>
                <GridItem w='100%' h='10' onClick={toggleColorMode} cursor={'pointer'} alignContent="center">
                  <Image
                    height={{ base: "30px", md: "40px" }}
                    width={{ base: "30px", md: "40px" }}
                    src={colorMode === 'light' ? "/assets/images/svg/blacksun.svg" : "/assets/images/svg/headersun.svg"}
                    alt="Sun Icon"
                  />
                </GridItem>
                <GridItem w='100%' h='10' display={{ base: 'none', md: 'block' }} >
                  <Image
                    src={colorMode === 'light' ? "/assets/images/svg/instawhite.svg" : "/assets/images/svg/instgramheader.svg"}
                    alt="Sun Icon"
                  />
                </GridItem>
                <GridItem w='100%' h='10' display={{ base: 'none', md: 'block' }}>
                  <Image
                    src={colorMode === 'light' ? "/assets/images/svg/twitterwhite.svg" : "/assets/images/svg/Twitter.svg"}
                    alt="Sun Icon"
                  />
                </GridItem>
                <GridItem w='100%' h='10' display={{ base: 'none', md: 'block' }}>
                  <Image
                    src={colorMode === 'light' ? "/assets/images/svg/linkdinwhite.svg" : "/assets/images/svg/Linkedin.svg"}
                    alt="Sun Icon"
                  />
                </GridItem>
              </Grid>
            </Box>
          </HStack>
        </Flex >
        {/* Drawer for Sidebar */}
        <Drawer isOpen={isOpen} placement="left" onClose={onClose} >

          <DrawerOverlay />
          <DrawerContent
            bg={bg}
            width="auto"
            animation={`${diagonalSlideAnimation} 0.8s ease-out`}

            maxWidth={{ base: '279px', md: '53vw' }}
          >
            <DrawerCloseButton color={color} />
            <DrawerBody>
              <Stack
                spacing={{ base: 5, md: 35 }}
                alignItems="flex-start"
                pl={{ base: '10px', md: '55px' }}
                pt={{ base: '30px', md: '60px' }}

              >
                {['Home', 'Services', 'About Us', 'Contact Us'].map((link, index) => (
                  <React.Fragment key={index}>
                    <HStack align="center" spacing={2}>
                      <Image
                        src={
                          colorMode === 'light'
                            ? '/assets/images/svg/arrowwhite.svg'
                            : '/assets/images/svg/arrowsidebar.svg'
                        }
                        alt="Arrow Icon"
                        height={{ base: '12px', md: '60px' }}
                        width={{ base: '12px', md: '60px' }}
                      />
                      <Link
                        to={
                          link === 'Home'
                            ? '/'
                            : link === 'Services'
                              ? '/service'
                              : link === 'About Us'
                                ? '/about'
                                : '/contact'
                        }
                        style={{ textDecoration: 'none' }}
                        onClick={onClose}
                      >
                        <Box
                          fontFamily="'Cags Hetonal', sans-serif"
                          fontSize={{ base: '20px', md: '100px' }}
                          fontWeight="400"
                          lineHeight={{ base: '24px', md: '90px' }}
                          textAlign="left"
                        >
                          {link}
                        </Box>
                      </Link>
                      {link === 'Services' && (
                        <Image
                          src={
                            colorMode === 'light'
                              ? showServices
                                ? '/assets/images/svg/croswhite.svg'
                                : '/assets/images/svg/pluswhite.svg'
                              : showServices
                                ? '/assets/images/svg/servicearrow.svg'
                                : '/assets/images/svg/sidebararrowservice.svg'
                          }
                          height={{ base: '10px', md: '32px' }}
                          width={{ base: '10px', md: '32px' }}
                          onClick={handleServicesClick}
                          cursor="pointer"
                        />
                      )}
                    </HStack>
                    
                    {link === 'Services' && showServices && (
                      <Stack
                        spacing={2}
                        pt="0px"
                      >
                        {[
                          { name: 'Digital Branding Solutions', path: '/digitalbranding' },
                          { name: 'Awareness Growth Solutions', path: '/awarenesssoutions' },
                          { name: 'Revenue Growth Solutions', path: '/revenuegrowth' },
                          { name: 'Social Media Management', path: '/socialmedia' },
                          { name: 'SEO', path: '/seo' },
                          { name: 'Performance Marketing', path: '/performancemarketing' },
                        ].map((service, serviceIndex) => (
                          <Box key={serviceIndex}>
                            <Link
                              to={service.path}
                              onClick={onClose}
                              style={{ textDecoration: 'none' }}
                            >
                              <Box
                                fontSize={{ base: '16px', md: '32px' }}
                                fontFamily="'Gilroy-SemiBold', sans-serif"
                                color={color}
                                pl="8px"
                              >
                                {service.name}
                              </Box>
                            </Link>
                            <Box
                              mt="5px"
                              borderBottom={`1px solid ${colorMode === 'dark' ? '#302F2F' : '#E3E3E3'}`}
                              width="100%"
                            />
                          </Box>
                        ))}
                      </Stack>
                    )}
                  </React.Fragment>
                ))}
              </Stack>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </Box >
    </>
  );
}




// import React from 'react';
// import {
//   Box,
//   Flex,
//   HStack,
//   IconButton,
//   useDisclosure,
// } from '@chakra-ui/react';
// import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
// import { Global } from '@emotion/react';
// import { globalStyles } from '../../styles/global-styles'; // Adjust the path


// export default function Header() {
//   const { isOpen, onOpen, onClose } = useDisclosure();

//   return (
//     <>
//       <Global styles={globalStyles} />

//       <Box color="white">
//         <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
//           {/* Left Icon */}

//           <HStack>
//             <Box
//               as="span"
//               ml={2}
//               fontWeight={400}
//               fontSize={36}
//               lineHeight={43}
//             >
//               Menu
//             </Box>
//             <img
//               src="/assets/images/svg/arrow.svg"
//               alt="First Icon"
//             />
//           </HStack>

//           {/* Menu Button */}
//           <IconButton
//             size={'md'}
//             icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
//             aria-label={'Open Menu'}
//             display={{ md: 'none' }}
//             onClick={isOpen ? onClose : onOpen}
//           />


//           {/* Center Icon */}
//           <HStack>
//             <img
//               src="/assets/images/svg/raretoss.svg"
//               alt="Second Icon"
//             />
//           </HStack>

//           {/* Right Icon */}
//           <HStack>
//             <img
//               src="/assets/images/svg/instgram.svg"
//               alt="Third Icon"
//             />
//           </HStack>
//         </Flex>

//         {/* Mobile Menu */}
//         {isOpen ? (
//           <Box pb={4} display={{ md: 'none' }}>
//             <HStack as={'nav'} spacing={4}>
//               {/* Add links here if needed */}
//             </HStack>
//           </Box>
//         ) : null}
//       </Box>

//     </>
//   );
// }
